import { toastMessage } from "./toast.actions";
export { toastMessage };
try {
    // @ts-ignore
    toastMessage.displayName = "toastMessage";
    // @ts-ignore
    toastMessage.__docgenInfo = { "description": "", "displayName": "toastMessage", "props": { "message": { "defaultValue": null, "description": "", "name": "message", "required": true, "type": { "name": "string" } }, "position": { "defaultValue": null, "description": "", "name": "position", "required": false, "type": { "name": "\"bottom\" | \"top\"" } }, "duration": { "defaultValue": null, "description": "", "name": "duration", "required": false, "type": { "name": "number" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Toast/actions/index.ts#toastMessage"] = { docgenInfo: toastMessage.__docgenInfo, name: "toastMessage", path: "src/shared/containers/Toast/actions/index.ts#toastMessage" };
}
catch (__react_docgen_typescript_loader_error) { }